import script from "./input-switch.vue?vue&type=script&setup=true&lang=js"
export * from "./input-switch.vue?vue&type=script&setup=true&lang=js"

import "./input-switch.vue?vue&type=style&index=0&id=f8acd35c&lang=css"

const __exports__ = script;

export default __exports__